import React,{useEffect,useState} from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { useDispatch, useSelector } from "react-redux"
import { Container, Row, Col, Form, Button,Modal,CloseButton } from "react-bootstrap"
import { AvisItem } from "../../components";
import { SET_FORMULE } from "../../constants/actions";
import { useHistory } from "react-router";
import Carousel from 'react-bootstrap/Carousel'
import Slider from "react-slick";
import { getTarifs , getPage} from "../../actions/mixedmode";
import { setFormule} from "../../actions/user";
import { BASE_URL_PROD } from "../../components/config/keys";
import { defaultimg } from "../../assets/images";
import { apiClient } from "../../actions/api"

const Page = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const history = useHistory()
    const queryParams = new URLSearchParams(window.location.search);

     const [show,setShow]=useState(false);
     const [formules,setFormules]=useState([]);
     const [readplus,setReadPlus]=useState(0);
     const [curenttarif,setCurenttarif]=useState({});
     const idtherapeute = queryParams.get('therapeute');
   
     const { data,pageinfo,tarifs } = useSelector(state => state.mixedmode);
     const { user,formule } = useSelector(state => state.user);
 
     // États pour le système de codes de réduction
     const [currentDiscount, setCurrentDiscount] = useState(null);

    useEffect(()=>{
      dispatch(getTarifs(idtherapeute?idtherapeute : ''))
      dispatch(getPage(55))
      
      // Récupérer le code de réduction si l'utilisateur est connecté
      if(user?.api_token) {
        getCurrentDiscountCode();
      }
    },[])

    // Récupérer le code de réduction actuel
    function getCurrentDiscountCode() {
        apiClient().get('/discount-codes/current', { 
            headers: { 'Authorization': `Bearer ${user.api_token}` }
        })
        .then((res) => {
            if (res.data.success === 'ok') {
                if (res.data.data.has_code) {
                    setCurrentDiscount(res.data.data.data);
                }
            }
        })
        .catch((error) => {
            console.log('Erreur lors de la récupération du code actuel:', error);
        });
    }

    // Fonction pour calculer le prix avec réduction
    const calculateDiscountedPrice = (originalPrice, discountData) => {
        if (!discountData || !discountData.is_valid) {
            return {
                original: originalPrice,
                discounted: originalPrice,
                hasDiscount: false,
                savings: 0,
                percentage: 0
            };
        }

        const percentage = discountData.reduction_percentage;
        const savings = originalPrice * (percentage / 100);
        const discountedPrice = originalPrice - savings;

        return {
            original: originalPrice,
            discounted: discountedPrice,
            hasDiscount: true,
            savings: savings,
            percentage: percentage
        };
    };

    const handleClick = (slug) => {
        history.push(slug);
    }

    const handleClose = () => setShow(false);
 
    const handleShow = (item) => {
        setFormules([])
        setCurenttarif(item)
        setShow(true);

        apiClient().get(`/formules/`+item.id)
        .then((res) => {
            setFormules(res.data)
        })
    }
 
    const goToFromCard = (item) => {
        apiClient().get(`/formules/` + item.id)
            .then((res) => {
                const firstFormule = res.data[0]
                if (formule?.therapeut) {
                    dispatch({ type: SET_FORMULE, payload: { 'tarif': item, 'formule': firstFormule, 'therapeut': formule.therapeut } })
                    history.push(`/profil-therapeute/${formule.therapeut.name}/${formule.therapeut.user_id}`)
                } else {
                    dispatch({ type: SET_FORMULE, payload: { 'tarif': item, 'formule': firstFormule } })
                    history.push('/list-psychologue')
                }
            })
    }

    const goTo = (item) => {
        if(formule?.therapeut){
            let params={'tarif':curenttarif, 'formule':item,'therapeut':formule.therapeut}
            dispatch({ type: SET_FORMULE, payload: params })
            history.push(`/profil-therapeute/${formule.therapeut.name}/${formule.therapeut.user_id}`);
        }
        else{
            dispatch({ type: SET_FORMULE, payload: {'tarif':curenttarif, 'formule':item} })
            history.push('/list-psychologue')
        }
    }

    // Composant pour afficher le prix avec ou sans réduction
    const PriceDisplay = ({ price }) => {
        const priceDetails = calculateDiscountedPrice(parseFloat(price), currentDiscount);
        
        if (priceDetails.hasDiscount) {
            return (
                <div className="price-with-discount">
                    <h4 className="original-price">
                        <span style={{textDecoration: 'line-through', color: '#FF914D', fontSize: '0.8em'}}>
                            {priceDetails.original.toFixed(2)}€
                        </span>
                    </h4>
                    <h4 className="discounted-price" style={{color: '#43c3cc'}}>
                        {priceDetails.discounted.toFixed(2)}€<span><sup>/séance</sup></span>
                    </h4>
                    <div style={{textAlign: 'center', marginTop: '8px'}}>
                        <div className="savings-badge" style={{
                            background: '#28a745', 
                            color: 'white', 
                            padding: '4px 8px', 
                            borderRadius: '4px', 
                            fontSize: '0.75em',
                            display: 'inline-block'
                        }}>
                            -{priceDetails.percentage}% • Économie: {priceDetails.savings.toFixed(2)}€
                        </div>
                    </div>
                </div>
            );
        }
        
        return <h4>{priceDetails.original.toFixed(2)}€<span><sup>/séance</sup></span></h4>;
    };

    return (
        <div className="home tarifs" >
            <section>
                <div className="ps-breadcrumb">
                    <div className="container">
                        <div className="ps-container">
                            <ul className="breadcrumb">
                                <li><a href="#" onClick={()=>history.push(`/`)}>{t('nav.home')}</a></li>
                                <li>{t('pricing.title')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section2 " >
                <Container>
                    <h2 className="text-center mb-3">  {idtherapeute ? t('pricing.choose_formula') : getTranslation(pageinfo?.titre, i18n.language)} <br/><span> </span> </h2>
                    <div dangerouslySetInnerHTML={{ __html: getTranslation(pageinfo?.contenu, i18n.language)}}></div>
                </Container>
            </section>

            <section className="section2 section " >
                <Container>
                    {/* Affichage du code de réduction actif */}
                    {currentDiscount && (
                        <Row>
                            <Col md={12}>
                                <div className="alert alert-success discount-alert-tarifs">
                                    <i className="fa fa-check-circle"></i> 
                                    <strong> Code de réduction actif : {currentDiscount.code}</strong>
                                    <br/>
                                    <small>
                                        Bénéficiez de {currentDiscount.reduction_formattee} sur toutes vos consultations
                                    </small>
                                </div>
                            </Col>
                        </Row>
                    )}

                    <Row className="ps-block--site-features ps-block--site-features-2">
                        {tarifs.map((item,i) => (
                            <Col md={4} style={{marginBottom:'20px'}} key={i}>
                                <div className="ps-block__item pocket-shadow">
                                    <div className="ps-block__left text-center"><img src={item.image}/></div>
                                    <div className="ps-block__right">
                                        {item.price && (
                                            <p className="text-center" style={{fontSize: '3rem', fontWeight: 'bold', color: '#43c3cc'}}>
                                                {parseFloat(item.price).toFixed(2)} €
                                            </p>
                                        )}
                                        <h4 className="text-center">{getTranslation(item.titre, i18n.language)}</h4>
                                        <p className="text-center">{getTranslation(item.description, i18n.language)}</p>
                                    </div>
                                    <div className="text-center" >
                                        <br/>
                                        <a href='javascript:void(0)' onClick={()=>goToFromCard(item)} className='btnlink marauto'>
                                            {t('appointment.book_button')} <i className='fa fa-long-arrow-right'></i>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <div className='forseparatefooter'></div>

            <Modal show={show} onHide={handleClose} className='modelhermixtarif' size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header>
                    <CloseButton variant="dark" onClick={handleClose} />
                </Modal.Header>
                <Modal.Body>
                    <div className='flexrowtarifs row'>
                        <div className='col-md-12'>
                            <div className="text-center flowpriceheader">
                                <img src={curenttarif?.image}/>
                                <h2>{getTranslation(curenttarif?.titre, i18n.language)}</h2>
                            </div>
                        </div>

                        {/* Affichage du code de réduction dans la modal */}
                        {currentDiscount && (
                            <div className='col-md-12' style={{marginBottom: '15px'}}>
                                <div className="alert alert-info text-center" style={{
                                    background: 'linear-gradient(90deg, #43c3cc 0%, #4fc5cd 35%, #6feaf2 100%)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px'
                                }}>
                                    <i className="fa fa-percent"></i> <strong>Code {currentDiscount.code} appliqué</strong> - 
                                    Réduction de {currentDiscount.reduction_formattee} sur ces tarifs
                                </div>
                            </div>
                        )}

                        {formules?.map((item, i) => (
                            getTranslation(item?.titre, 'fr') !== "Formule Introspection" ? (
                                <div className='item col-md-4' key={i}>
                                    <div className='pricebox'>
                                        <h3>{getTranslation(item?.titre, i18n.language)}</h3>
                                        
                                        {/* Utilisation du composant PriceDisplay */}
                                        <PriceDisplay price={item?.price} />
                                        
                                        <div className="pricebox-border2"> </div>
                                        <div className='ttcontent'>
                                            <ul className='col-9028-K'>
                                                {getTranslation(curenttarif?.titre, 'fr') === 'Adolescent' && (
                                                    <>
                                                        <li><i className='fa fa-check-circle icochecked'></i>{t('pricing.adolescent_age_range')}</li>
                                                        <li><i className='fa fa-check-circle icochecked'></i>{t('pricing.parental_auth_required')}</li>
                                                    </>
                                                )}

                                                <li><i className='fa fa-check-circle icochecked'></i> {item?.temps} {t('pricing.min_unit')}</li>
                                                <li style={{ display: 'none' }}><i className='fa fa-check-circle icochecked'></i> {item?.seance} {item?.seance > 1 ? t('pricing.session_plural') : t('pricing.session_singular')}</li>
                                                <li><i className='fa fa-check-circle icochecked'></i> {item?.pack}</li>

                                                {getTranslation(curenttarif?.titre, 'fr') === 'Groupe de parole' && (
                                                    <li><i className='fa fa-check-circle icochecked'></i> {t('pricing.group_participants')}</li>
                                                )}
                                            </ul>

                                            <label>{t('common.description')}</label>
                                            <p>
                                                {item.id === readplus ? getTranslation(item.contenu, i18n.language) : item.shotconte}
                                                <br/>
                                                {item.id !== readplus && item.show === 1 && (
                                                    <a href='javascript:void(0)' onClick={() => setReadPlus(item.id)}>{t('common.read_more')}</a>
                                                )}
                                            </p>

                                            <div className="text-center">
                                                <a href='javascript:void(0)' onClick={() => goTo(item)} className='btnlink marauto'>
                                                    {t('appointment.book_button')}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        ))}
            
                        {getTranslation(curenttarif?.titre, 'fr') =='Adolescent' && (
                            <div style={{marginTop: '45px'}} className='alert alert-danger '>
                                {t('pricing.parental_auth_notice')}
                            </div>
                        )}

                        <div style={{marginTop: '45px'}} className='alert '>
                            <img className="hotline" src="/images/callservices.png"/>  
                            <span>{t('pricing.questions_prefix')} <span onClick={()=>history.push('/aide')} style={{color:'#17a2b8',textDecoration: 'underline'}}>{t('pricing.faq_link')}</span> {t('pricing.questions_middle')} <span style={{color:'#17a2b8',textDecoration: 'underline'}} onClick={()=>history.push('/contact')} >Feel Better™</span></span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Page;